/* eslint-disable max-len */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { ConversationParticipant, ConversationUserReference, UserPermissions, User } from '@centecomm/portal-service';
import { Add, Close, IconColors } from 'Icons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Title } from 'Shared';
import { FlexWrapper } from 'Shared/FlexWrapper';
import ModalWithAction from 'Shared/Modal/ModalWithAction';
import { hasValidRecord } from 'utils';
import ProtectedComponent from '../../../Core/ProtectedComponent';
import styles from '../ConversationUsersPanel/conversation-users-panel.module.css';
import stylesParticipants from './conversation-participants.module.css';

export interface ConversationParticipantsProps {
    currentUser: User;
    participants: ConversationParticipant[];
    onAddUserHandler: () => void;
    onRemoveUserHandler: (arg?: ConversationUserReference) => void;
}

function ConversationParticipants({
    currentUser,
    participants,
    onAddUserHandler,
    onRemoveUserHandler,
}: ConversationParticipantsProps): React.ReactElement<ConversationParticipantsProps> {
    const { t } = useTranslation(['conversationsFeature', 'buttons', 'common']);
    const [showRemoveParticipantModal, setShowRemoveParticipantModal] = React.useState(false);
    const [removableParticipant, setRemovableParticipant] = React.useState<ConversationUserReference>();

    const handleRemoveUser = (participant: ConversationUserReference) => {
        setRemovableParticipant(participant);
        setShowRemoveParticipantModal(true);
    };

    const removeParticipant = () => {
        onRemoveUserHandler(removableParticipant);
        setShowRemoveParticipantModal(false);
    };

    return (
        <>
            <FlexWrapper
                column
                align="start"
                justify="start"
                gap="0.35rem"
                className={stylesParticipants.conversationParticipantsContainer}
            >
                <FlexWrapper align="center" justify="between" fullWidth>
                    <Title
                        title={t('conversationsFeature:conversationDetail.participants.title')}
                        level="h3"
                        noMarginBottom
                    />
                    <div
                        onClick={onAddUserHandler}
                        className={stylesParticipants.addParticipantButton}
                        title={t('conversationsFeature:conversationDetail.participants.addParticipantButton')}
                    >
                        <Add aspect="1.5rem" color={IconColors.Action} />
                    </div>
                </FlexWrapper>
                <ul className={styles.UsersList} style={{ marginTop: 0, paddingTop: 0 }}>
                    {participants.map((userReference: ConversationUserReference) => (
                        <li key={`users-panel-${userReference.userId}`} className={styles.User}>
                            <FlexWrapper
                                key={userReference.userId}
                                className={styles.UserName}
                                align="start"
                                justify="start"
                                gap="0.5rem"
                            >
                                {userReference.userName}
                                {userReference.userId === currentUser?.id ? <span>({t('common:you')})</span> : <></>}
                                <ProtectedComponent permissions={[UserPermissions.RemoveUserFromConversation]}>
                                    <div onClick={() => handleRemoveUser(userReference)}>
                                        <Close aspect="1.2rem" color={IconColors.WarningRed} />
                                    </div>
                                </ProtectedComponent>
                            </FlexWrapper>
                            {hasValidRecord(userReference.email) && (
                                <p className={styles.UserEmail}>{userReference.email}</p>
                            )}
                        </li>
                    ))}
                </ul>
            </FlexWrapper>
            {showRemoveParticipantModal && (
                <ModalWithAction
                    header={t('conversationsFeature:conversationDetail.participants.modal.header')}
                    actionText={t('buttons:confirm')}
                    actionCallback={removeParticipant}
                    cancelCallback={() => setShowRemoveParticipantModal(false)}
                >
                    <FlexWrapper align="start" justify="start" column gap="1rem" style={{ padding: '1rem 1rem 0 1rem' }}>
                        <div style={{ width: '400px' }}>
                            {removableParticipant?.userId === currentUser?.id ? (
                                <div>
                                    <Title
                                        level="h3"
                                        title={t(
                                            'conversationsFeature:conversationDetail.participants.modal.actions.leave.body.title',
                                        )}
                                    />
                                    <p>
                                        {t(
                                            'conversationsFeature:conversationDetail.participants.modal.actions.leave.body.main',
                                        )}
                                    </p>
                                    <Title
                                        level="h4"
                                        title={t(
                                            'conversationsFeature:conversationDetail.participants.modal.actions.leave.body.confirm',
                                        )}
                                        noMarginBottom
                                    />
                                </div>
                            ) : (
                                <div>
                                    <Title
                                        level="h3"
                                        title={t(
                                            'conversationsFeature:conversationDetail.participants.modal.actions.remove.body.title',
                                        )}
                                    />
                                    <p style={{ marginBottom: '1rem' }}>
                                        {t(
                                            'conversationsFeature:conversationDetail.participants.modal.actions.remove.body.main',
                                        )}
                                    </p>

                                    <Title level="h3" title={`${t('common:user')}:`} />

                                    <div style={{ marginLeft: '1rem' }}>
                                        <p style={{ fontWeight: 700, fontSize: '1.2rem' }}>
                                            {removableParticipant?.userName}
                                        </p>
                                        <p style={{ color: IconColors.DarkGrey }}>{removableParticipant?.email}</p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </FlexWrapper>
                </ModalWithAction>
            )}
        </>
    );
}

export default ConversationParticipants;
